import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LaudoInputFotoAdicional } from 'src/app/models/laudo-input-foto-adicional';
import { LaudoFotoAdicionalService } from 'src/app/services/http/laudo-foto-adicional.service';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { ActivatedRoute } from '@angular/router';
import { Utils } from 'src/app/utils/utils';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-form-img-adicional-laudo',
  templateUrl: './form-img-adicional-laudo.component.html',
  styleUrls: ['./form-img-adicional-laudo.component.scss']
})
export class FormImgAdicionalLaudoComponent implements OnInit {

  @Input() formId = null;
  listaFotos = [];
  form = new FormGroup({
    label: new FormControl('', [Validators.required]),
    image: new FormControl('', [Validators.required]),
  });
  token = '';

  constructor(private laudoFotoAdicionalService: LaudoFotoAdicionalService, laudoService: LaudoUnionService,private activatedRoute: ActivatedRoute, private msgService: ModalMsgService) { }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.paramMap.get('id');
    this.laudoFotoAdicionalService.getFotosAdicionais(this.token)
    .then(r => this.listaFotos = r.map(f => new LaudoInputFotoAdicional(f)));
  }

  async sendForm() {
    if (this.form.invalid || this.form.value.image == true) {

      this.form.markAllAsTouched();
      this.msgService.openDialog('Campos ausentes ou incorretos!', "Favor inserir uma descrição e uma foto válida.", 'info');
      return;
    }

    let imageBase64 = this.form.value.image;
    let label = this.form.value.label;
    let input = new LaudoInputFotoAdicional({ id: null, label: label, image: ''});
    this.form.patchValue({label: '', image: ''});
    this.submitInput(input, imageBase64);
  }

  async submitInput(input:LaudoInputFotoAdicional, imageBase64) {
    input.loading = true;
    //adiciona a foto adicional a lista caso ela nao tenha um id (ou seja, nao é um update)
    if(!input.id) {
      this.listaFotos.unshift(input);
    }
    try {
      let imgBlob = imageBase64 ? await Utils.base64ToBlob(imageBase64) : '';
      await this.laudoFotoAdicionalService.updateFotoAdicional(input.label.value, input.image.value, imgBlob, input.id, this.token )
      .then(response => {
        input.id = response.id;
        input.image.patchValue(response.value);
        input.label.patchValue(response.descricao);
        input.loading = false;
        this.aguardar(3000);
      }).catch(e=>{
        throw new Error(e)
      });
      return;
    } catch (error) {
      //remove caso não seja um update edeu erro
      if(!input.id) {
        this.listaFotos = this.listaFotos.filter( fl => fl != input );
      } else {
        input.loading = false;
      }
      console.error( 'ERRO AO SALVAR IMAGEM ADICIONAL ->', error );
      return false;
    }
  }

  async addFotoAdicional(id, label, imageBase64) {
    let input = new LaudoInputFotoAdicional({ id, label, image:'', loading: true });
    return await this.submitInput(input, imageBase64); 
  }

  removeFotoAdicional(f:LaudoInputFotoAdicional) {
    f.loading = false;
    this.laudoFotoAdicionalService.removeFotoAdicional(f.id, this.token)
    .then( r => this.listaFotos = this.listaFotos.filter( fl => fl != f ) )
    .catch( r => {
      console.error('Erro ao remover foto adicional -> ', r);
      f.loading = false;
    })
  }

  async updateFotoAdicional(input, imageBase64) {
    return await this.submitInput(input, imageBase64);
  }

  updateLabel(input) {
    this.submitInput(input, '');
  }

  aguardar(milisegundos) {
    setTimeout(function () {
      var botoes = document.getElementById("btnM");
      botoes.click();
    }, milisegundos);
  }

}


